import { render, staticRenderFns } from "./12_ap_regulaciones.vue?vue&type=template&id=f10c3a56&scoped=true&"
import script from "./12_ap_regulaciones.vue?vue&type=script&lang=js&"
export * from "./12_ap_regulaciones.vue?vue&type=script&lang=js&"
import style0 from "./12_ap_regulaciones.vue?vue&type=style&index=0&id=f10c3a56&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f10c3a56",
  null
  
)

export default component.exports